import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import "./ReportTypeModal.css";
import FormFieldError from "components/common/form_error/form_field_error";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const ReportTypeModal = ({ onClose, isModalOpen, handleGenerateReport }) => {
  const report31DayOptions = [
    { billingCode: 99453, label: "Initiation Code" },
    {
      billingCode: 99454,
      label: "Includes 16 days of reading within 31 days from today",
    },
    {
      billingCode: 99457,
      label: "Include the communication log within 31 days from today",
    },
    {
      billingCode: 99458,
      label:
        "Include the logs for more than 20 mins spent in the communication logs",
    },
  ];

  const [show31DayOptions, setShow31DayOptions] = useState(false);
  const [show31DayWithAlertOptions, setShow31DayWithAlertOptions] =
    useState(false);
  const [selectedBillingCodes, setSelectedBillingCodes] = useState([]);
  const [showError, setShowError] = useState(false);

  const handleReportTypeChange = (event) => {
    const {
      target: { value: selectReportType },
    } = event;
    const is31DaySelected = selectReportType === "31_days";
    const is31DayWithAlertSelected = selectReportType === "31_days_with_alert";
    setSelectedBillingCodes([]);
    setShow31DayOptions(is31DaySelected);
    setShow31DayWithAlertOptions(is31DayWithAlertSelected);
    setShowError(false);
  };

  const handleBillingCodeCheck = (event) => {
    const billingCode = Number(event.target.name);
    setShowError(false);

    if (event.target.checked) {
      setSelectedBillingCodes((prevSelected) => [...prevSelected, billingCode]);
    } else {
      setSelectedBillingCodes((prevSelected) =>
        prevSelected.filter((code) => code !== billingCode)
      );
    }
  };

  const handleGenerateReportClick = () => {
    if (show31DayOptions && selectedBillingCodes.length === 0) {
      return setShowError(true);
    }
    setShowError(false);
    handleGenerateReport({
      billingCodes: selectedBillingCodes,
      reportOf31DayWithAlert: show31DayWithAlertOptions,
    });
  };

  return (
    <ModalWrapper
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      title="Select Report Type"
    >
      <div className="mt-2">
        <FormControl>
          <span>Select a report type to download</span>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="last_billing_date"
            name="radio-buttons-group"
          >
            <FormControlLabel
              value="last_billing_date"
              control={<Radio />}
              label="Report from the last billing date"
              onChange={handleReportTypeChange}
            />
            <FormControlLabel
              value="31_days"
              control={<Radio />}
              label="Report of 31 days from today"
              onChange={handleReportTypeChange}
            />
            {show31DayOptions && (
              <div className="billing_code_options">
                <FormGroup>
                  {report31DayOptions.map((option) => (
                    <FormControlLabel
                      className="mt-2"
                      label={
                        <div className="report-31day-options">
                          <div className="checkbox-container">
                            <Checkbox
                              name={option.billingCode}
                              className="billing_code_options_checkbox"
                              onChange={handleBillingCodeCheck}
                            />
                          </div>
                          <div className="billing-details">
                            <Typography variant="body1">
                              {option.billingCode}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {option.label}
                            </Typography>
                          </div>
                        </div>
                      }
                      control={<></>}
                    />
                  ))}
                </FormGroup>
                {showError && (
                  <FormFieldError errorMessage="Select atleast one billing code." />
                )}
              </div>
            )}
            <FormControlLabel
              value="31_days_with_alert"
              control={<Radio />}
              label="Report of 31 days from today with Alerts"
              onChange={handleReportTypeChange}
            />
          </RadioGroup>
        </FormControl>
      </div>

      <div className="mt-2 report-type-modal__footer">
        <Button
          variant="outlined"
          color="primary"
          style={{ margin: "1%" }}
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleGenerateReportClick}
          style={{
            margin: "1%",
            backgroundColor: "#94ba33",
            color: "white",
          }}
        >
          Generate Report
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default ReportTypeModal;
